var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.279 6.46 9.54 3.72l1.34-1.313 2.711 2.71zM4.887 14H2v-2.888l6.112-5.99 2.767 2.765zM11.595.293a1 1 0 0 0-1.407-.007L.3 9.978a1 1 0 0 0-.3.714V15a1 1 0 0 0 1 1h4.308a1 1 0 0 0 .714-.3l9.692-9.888c.383-.392.38-1.02-.008-1.408z",
    clipRule: "evenodd"
  })));
};
export default SvgPen;